/* tslint:disable */
/* eslint-disable */
/**
 * timereport-service
 * timereport-service
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceMonth = {
    Full: 'Full',
    FirstMonth: 'FirstMonth',
    SecondMonth: 'SecondMonth'
} as const;

export type InvoiceMonth = typeof InvoiceMonth[keyof typeof InvoiceMonth];



